export const GET_ALL_SURVEYS_BY_COUNTRY = 'GET_ALL_SURVEYS_BY_COUNTRY'
export const SET_ALL_SURVEYS_BY_COUNTRY = 'SET_ALL_SURVEYS_BY_COUNTRY'

export const SEND_SURVEY_ANSWER = 'SEND_SURVEY_ANSWER'
export const SET_ANSWERS_SENDING_RESULT = 'SET_ANSWERS_SENDING_RESULT'

export const SURVEY_ANSWERED = 'Already answered'

export const GET_ALL_SURVEYS_BY_COUNTRY_PROCESS = 'getAllSurveyByCountryProcess'
export const SEND_SURVEY_ANSWER_PROCESS = 'sendSurveyAnswerProcess'

export const GET_ALL_SURVEY_BY_COUNTRY_ADMIN = 'GET_ALL_SURVEY_BY_COUNTRY_ADMIN'
export const SET_ALL_SURVEY_BY_COUNTRY_ADMIN = 'SET_ALL_SURVEY_BY_COUNTRY_ADMIN'

export const GET_SURVEY_RESULTS_BY_ID = 'GET_SURVEY_RESULTS_BY_ID'
export const SET_SURVEY_RESULTS_BY_ID = 'SET_SURVEY_RESULTS_BY_ID'
export const CLEAR_SURVEY_RESULTS_VALUE = 'CLEAR_SURVEY_RESULTS_VALUE'

export const GET_SURVEY_TEXT_ANSWER_BY_ID = 'GET_SURVEY_TEXT_ANSWER_BY_ID'
export const SET_SURVEY_TEXT_ANSWER_BY_ID = 'SET_SURVEY_TEXT_ANSWER_BY_ID'

export const SET_ACTUAL_SURVEY_BY_COUNTRY_ADMIN = 'SET_ACTUAL_SURVEY_BY_COUNTRY_ADMIN'
export const SET_CHART_DATA = 'SET_CHART_DATA'

export const ADD_NEW_SURVEY_BY_COUNTRY = 'ADD_NEW_SURVEY_BY_COUNTRY'
export const ADD_NEW_SURVEY_BY_COUNTRY_RESULT = 'ADD_NEW_SURVEY_BY_COUNTRY_RESULT'
export const ADD_NEW_SURVEY_BY_COUNTRY_ERROR = 'ADD_NEW_SURVEY_BY_COUNTRY_ERROR'
export const CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_RESULT = 'CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_RESULT'
export const CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_ERROR = 'CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_ERROR'

export const CLEAR_ANSWER_SENT_INDICATOR = 'CLEAR_ANSWER_SENT_INDICATOR'

export const GET_SURVEY_CSV = 'GET_SURVEY_CSV'
export const SET_CSV_DATA = 'SET_CSV_DATA'

export const SURVEY_FORM_FIELDS_AMOUNT_MIN_FIRST_TAB = 8
export const SURVEY_FORM_FIELDS_AMOUNT_MAX_FIRST_TAB = 11
export const SURVEY_FORM_FIELDS_AMOUNT_MIN = 13
export const SURVEY_FORM_FIELDS_AMOUNT_MAX = 18
